var _rect, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAddWitthBackground(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 20,
    fill: "#343434"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.1262 19.2267H20.773V10.8735C20.773 10.4464 20.4268 10.1001 19.9996 10.1001C19.5724 10.1001 19.2262 10.4464 19.2262 10.8735V19.2267H10.873C10.4459 19.2267 10.0996 19.5729 10.0996 20.0001C10.0996 20.4273 10.4459 20.7735 10.873 20.7735H19.2262V29.1267C19.2262 29.5538 19.5724 29.9001 19.9996 29.9001C20.4268 29.9001 20.773 29.5538 20.773 29.1267V20.7735H29.1262C29.5533 20.7735 29.8996 20.4273 29.8996 20.0001C29.8996 19.5729 29.5533 19.2267 29.1262 19.2267Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddWitthBackground);
export default __webpack_public_path__ + "static/media/AddWitthBackground.3b293c868aa380dbab3eb3c6876ebd21.svg";
export { ForwardRef as ReactComponent };